import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  headerTitle: {
    padding: theme.spacing(0, 4),
    color: '#FFF',
    marginBottom: theme.spacing(2),
    animation: `${keyframes`
      from: { opacity: 0 }
      to: { opacity: 1 }
    `} 0.4s ease-out backwards`,
    animationDelay: '100ms',
    verticalAlign: 'middle',
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid rgba(255, 255, 255, 0.14)',
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
      padding: theme.spacing(0, 3),
      paddingTop: theme.spacing(3),
      marginTop: `${theme.spacing(-8)} !important`,
    },
    '& > *': {
      verticalAlign: 'middle',
    },
  },
  defaultTheme: {
    '& .MuiTypography-root': {
      color: '#FFF',
    },
  },
  center: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
}))
